export default __webpack_public_path__ + "static/media/solarbg3-portrait.8a4aca21.jpg";